const validateIsNull = (propertyValue: unknown): boolean => propertyValue === null;

export default validateIsNull;
